var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside"},[_c('img',{attrs:{"src":require("../assets/images/logo.png"),"alt":""}}),_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":"2"}},[_c('menuContent',{attrs:{"menus":_vm.menus}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }